module.exports = __webpack_public_path__ + "static/img/li.2942193.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/li.png
// module id = RLF9
// module chunks = 1